import { useMemo } from 'react';
import mapSectionsWithComponents from '../../utils/mapSectionsWithComponents';
import useApiData from '../../hooks/useApiData';
import Footer from '../../Components/Organisms/Footer';

const FooterBlock = () => {
  const apiPath = window?.drupalSettings?.api?.footer;
  const { data, error } = useApiData(apiPath);
  const sections = useMemo(
    () => (data ? mapSectionsWithComponents(data?.data?.footer) : {}),
    [data],
  );

  if (error) {
    return <p className="status status--error">{error.message}</p>;
  }

  return <Footer sections={sections} analytic={data?.data?.analytic} />;
};

export default FooterBlock;
